import {isDebug} from "@/helpers/environment";

export default function debuglog(...args) {
    if (isDebug()) {
        console.log.apply(this, args);
    }
}
